import { useNavigate } from 'react-router-dom';
import { useQuery as useConvexQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';
import { Plus, Shield } from 'lucide-react';
import Card from '../../components/Card';
import Button from '../../components/Button';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import { formatDateTime, getPrivilegeLabel } from '../../utils/helpers';

export default function AdminList() {
    const navigate = useNavigate();

    const admins = useConvexQuery(api.platformAdmins.getAllAdmins);

    const columns = [
        {
            header: 'Email',
            accessor: 'email',
            render: (admin) => (
                <div className="flex items-center gap-2">
                    <span className="font-medium">{admin.email}</span>
                    {admin.privileges.includes('super_admin') && (
                        <Shield size={16} className="text-red" />
                    )}
                </div>
            ),
        },
        {
            header: 'Privileges',
            accessor: 'privileges',
            render: (admin) => (
                <div className="flex flex-wrap gap-1">
                    {admin.privileges.slice(0, 3).map((privilege) => (
                        <Badge key={privilege} variant="primary">
                            {getPrivilegeLabel(privilege)}
                        </Badge>
                    ))}
                    {admin.privileges.length > 3 && (
                        <Badge variant="primary">+{admin.privileges.length - 3}</Badge>
                    )}
                </div>
            ),
        },
        {
            header: 'Last Active',
            accessor: 'lastActive',
            render: (admin) => (
                <span className="text-sm">{formatDateTime(admin.lastActive)}</span>
            ),
        },
        {
            header: 'Joined',
            accessor: 'createdAt',
            render: (admin) => (
                <span className="text-sm">{formatDateTime(admin.createdAt)}</span>
            ),
        },
    ];

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-bold mb-2">Admin Management</h1>
                    <p className="text-muted-light dark:text-muted-dark">
                        Manage platform administrators and their privileges
                    </p>
                </div>
                <Button variant="primary" onClick={() => navigate('/admins/add')}>
                    <Plus size={20} />
                    Add Admin
                </Button>
            </div>

            <Card>
                <Table
                    columns={columns}
                    data={admins || []}
                    loading={admins === undefined}
                    onRowClick={(admin) => navigate(`/admins/${admin._id}`)}
                    emptyState={{
                        title: 'No admins',
                        description: 'Add your first admin',
                    }}
                />
            </Card>
        </div>
    );
}

